module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flow-new/menu-icon-condition-c66d2f286f00b37b3c1ab7f1cf5ce421.png";